import React from 'react';
import { Navigate } from 'react-router-dom';

function ProtectedRoute({ children, requiredPermission }) {
  const isAuthenticated = localStorage.getItem('accessToken');
  const userPermissions = JSON.parse(localStorage.getItem('userPermissions') || '[]');

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Check if a specific permission is required and user has it
  if (requiredPermission && !userPermissions.includes(requiredPermission)) {
    // Redirect users without required permission to dashboard
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

export default ProtectedRoute;